lmApp.
  directive('lmInlineDatepicker', ['$timeout',
    function ($timeout) {
      return {
        restrict: 'E',
        replace: false,
        scope: {
          ngModel: '=',
          placeholder: '@',
          icon: '@',
          ngDisabled: '=?',
          noFuture: '@?',
          noPast: '@?',
          noSelects: '@?',
          showBefore: '@?'
        },
        link: function (scope, element, attrs) {
          scope._date_element_ = element;
          scope._table_ = element.find('.inline-picker__table');
          scope._picker_ = element.find('.inline-picker');
          scope.month = [];
          scope.rnd = moment.utc().unix();

          /**
           * Set 00:00:00 for day
           * @param date
           * @returns {moment}
           * @private
           */
          var _RemoveTime = function (date) {
            return date.startOf('day');
          };

          /**
           * Build month from data.
           * @param start - from what date start building
           * @param month - for what month
           * @private
           */
          var _BuildMonth = function (start, month) {
            scope.month = [];
            var done = false;
            var date = start.clone();
            var monthIndex = date.month();
            var count = 0;
            scope.month.push({
              name: scope.selectedMoment.clone().add(-1, "month").format('YYYY'),
              number: scope.selectedMoment.clone().add(-1, "month").format('MMM'),
              isCurrentMonth: true,
              isToday: false,
              isMonth: true,
              date: scope.selectedMoment.clone().add(-1, "month")
            });
            while (!done) {
              scope.month = _.union(scope.month, _BuildWeek(date.clone(), month));
              date.add(1, "w");
              done = count++ > 2 && monthIndex !== date.month();
              monthIndex = date.month();
            }
            scope.month.push({
              name: scope.selectedMoment.clone().add(1, "month").format('YYYY'),
              number: scope.selectedMoment.clone().add(1, "month").format('MMM'),
              isCurrentMonth: true,
              isToday: false,
              isMonth: true,
              date: scope.selectedMoment.clone().add(1, "month")
            });
          };

          /**
           * Build week for month
           * @param date - from what date start building
           * @param month - need to check is day from current month or not
           * @returns {Array.<Object>}
           * @private
           */
          var _BuildWeek = function (date, month) {
            var days = [];
            for (var i = 0; i < 7; i++) {
              days.push({
                name: date.format('ddd'),
                number: date.date(),
                month: date.month(),
                isCurrentMonth: date.month() === month.month(),
                isToday: date.isSame(new Date(), "day"),
                isLocked: !date.isSame(new Date(), "day") && (scope.noFuture && moment().diff(date) < 0) || (scope.noPast && moment().diff(date) > 0),
                date: date
              });
              date = date.clone();
              date.add(1, "d");
            }
            return days;
          };

          /**
           * [NG-CLICK] Select date
           * @param date
           */
          scope.selectDate = function (date) {
            if (!date.isLocked || date.isToday) {
              if (date.isMonth) {
                scope.selectedYear = date.date.format("YYYY");
                scope.selectedMonth = date.date.format("MMMM");
                return;
              }

              scope.selectedMoment.date(date.number);
              scope.selectedDate = scope.selectedMoment.format('D');
              scope.selectedDay = scope.selectedMoment.format('dddd');

              scope.ngModel = scope.selectedMoment;
            }
          };

          /**
           * [NG-CLICK] Select next MONTH
           */
          scope.next = function () {
            var start = scope.selectedMoment.clone();
            start.month(start.month() + 1);
            if (start.month() < scope.selectedMoment.month()) {
              scope.selectedYear = start.year();
              scope.selectedMoment.year(scope.selectedYear);
              scope.selectedYear = scope.selectedMoment.format('YYYY');
            }
            scope.selectedMonth = start.format('MMMM');
          };

          /**
           * [NG-CLICK] Select prev MONTH
           */
          scope.previous = function () {
            var start = scope.selectedMoment.clone();
            start.month(start.month() - 1);
            if (start.month() > scope.selectedMoment.month()) {
              scope.selectedYear = start.year();
              scope.selectedMoment.year(scope.selectedYear);
              scope.selectedYear = scope.selectedMoment.format('YYYY');
            }
            scope.selectedMonth = start.format('MMMM');
          };

          /**
           * [NG-IF] Check selected MONTH
           * @param month
           * @returns {boolean}
           */
          scope.isSelectedMonth = function (month) {
            return month === scope.selectedMonth;
          };

          /**
           * [NG-WATCH] Rebuild if month changed from DOM.select
           * @param month
           */
          scope.selectMonth = function (month) {
            var start = scope.selectedMoment.clone();
            start.month(month);
            start.date(1);
            _RemoveTime(start.day(0));
            scope.selectedMoment.month(month);
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');
            _BuildMonth(start, scope.selectedMoment);
            //scope.ngModel = scope.selectedMoment;
            if (scope.ngModel.format('MMMM YYYY') === scope.selectedMoment.format('MMMM YYYY')) {
              scope.slideToDay(scope.ngModel);
            } else {
              scope.slideToDay(scope.selectedMoment.clone().date(1));
            }
          };

          /**
           * [NG-IF] Check selected YAER
           * @param year
           * @returns {boolean}
           */
          scope.isSelectedYear = function (year) {
            return year === scope.selectedYear;
          };

          /**
           * [NG-IF] Check selected YAER
           * @param year
           * @returns {boolean}
           */
          scope.isSelectedDay = function (day) {
            return day.date.isSame(scope.selectedMoment) && (scope.ngModel.format('D MMMM YYYY') === scope.selectedMoment.format('D MMMM YYYY')) && !day.isMonth
          };

          /**
           * [NG-WATCH] Rebuild if year changed from DOM.select
           * @param year
           */
          scope.selectYear = function (year) {
            var start = scope.selectedMoment.clone();
            start.year(year);
            start.date(1);
            _RemoveTime(start.day(0));
            scope.selectedMoment.year(year);
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');
            _BuildMonth(start, scope.selectedMoment);
            if (scope.ngModel.format('MMMM YYYY') === scope.selectedMoment.format('MMMM YYYY')) {
              scope.slideToDay(scope.ngModel);
            } else {
              scope.slideToDay(scope.selectedMoment.clone().date(1));
            }
          };

          /**
           * [NG-CLICK] Set today date
           */
          scope.today = function () {
            scope.selectedMoment = _RemoveTime(moment.utc().startOf('day'));
            scope.selectedMonth = scope.selectedMoment.format('MMMM');
            scope.selectedYear = scope.selectedMoment.format('YYYY');
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');

            scope.slideToDay(scope.selectedMoment);

            scope.ngModel = scope.selectedMoment;
          };

          //scope.ngModel = _RemoveTime(scope.ngModel ? (moment.isMoment(scope.ngModel) ? angular.copy(scope.ngModel) : (moment.utc(scope.ngModel * 1000))) : moment.utc());
          scope.selectedMoment = _RemoveTime(scope.ngModel.clone() || moment.utc());

          scope.selectedYear = scope.selectedMoment.format('YYYY');
          scope.selectedMonth = scope.selectedMoment.format('MMMM');
          scope.selectedDate = scope.selectedMoment.format('D');
          scope.selectedDay = scope.selectedMoment.format('dddd');

          scope.selects = {
            years: [],
            months: []
          };

          scope.removeOne = scope.$watch('selectedYear', function (newVal, oldVal) {
            if (newVal !== oldVal) {
              scope.selectYear(newVal);
            }
          });

          scope.removeTwo = scope.$watch('selectedMonth', function (newVal, oldVal) {
            if (newVal !== oldVal) {
              scope.selectMonth(newVal);
            }
          });

          scope.slideLeft = function () {
            if (scope._table_.position().left + scope._picker_.width() / 2 < 0) {
              scope._table_.css({left: '+=' + scope._picker_.width() / 2});
            } else {
              scope._table_.css({left: '0'});
            }
          };

          scope.slideToDay = function (day) {
            for (var i = 0; i < scope.month.length; i++) {
              if (scope.month[i].number === day.date() && scope.month[i].isCurrentMonth) {
                $timeout(function () {
                  var ind = (i - parseInt(scope.showBefore || 7, 10)) < 0 ? 1 : i - parseInt(scope.showBefore || 7, 10);
                  var elem = angular.element('#day_' + scope.rnd + '_' + day.month() + '_' + ind);
                  scope._table_.css({left: elem.length ? -elem.position().left : 0});
                }, 350);
                break;
              }
            }
          };

          scope.slideRight = function () {
            if (scope._table_.find('.inline-picker__day--infocus').last().position().left +
              (scope._table_.position().left - scope._picker_.width() / 2) -
              scope._picker_.width() * 0.7 > 0) {
              scope._table_.css({left: '-=' + scope._picker_.width() / 2});
            } else {
              scope._table_.css({left: -(scope._table_.find('.inline-picker__day--infocus').last().position().left - scope._picker_.width() * 0.7)});
            }
          };

          var countYear = moment.utc().format("YYYY");
          countYear = moment.utc().year(parseInt(--countYear, 10)).format("YYYY");
          var countTo = parseInt(moment.utc().format("YYYY"), 10) + 4;
          while (countYear < countTo)  scope.selects.years.push(moment.utc().year(countYear++).format("YYYY"));

          var countMonth = 0;
          while (countMonth < 12) scope.selects.months.push(moment.utc().month(countMonth++).format("MMMM"));

          var start = scope.selectedMoment.clone();
          start.date(1);
          _RemoveTime(start.day(0));

          _BuildMonth(start, scope.selectedMoment);

          scope.slideToDay(scope.selectedMoment);

          var watcher = scope.$watch('ngModel', function (newValue, oldValue) {
            var value = angular.copy(newValue);
            scope.selectedMoment = _RemoveTime(value ? (moment.isMoment(value) ? angular.copy(value) : (moment.utc(value * 1000))) : moment.utc());
          });

          /**
           * Clear scope on $DESTROY
           */
          scope._date_element_.on('$destroy', function () {
            if (watcher) watcher();
            if (scope.removeOne) scope.removeOne();
            if (scope.removeTwo) scope.removeTwo();
            scope.$destroy();
          })
        },
        templateUrl: 'lm-inline-datepicker/lm-inline-datepicker.tpl.html'
      };
    }]);
